import { RenderInstruction, ValidateResult, ValidationRenderer } from 'aurelia-validation';

export class BootstrapGroupRenderer implements ValidationRenderer {
  allowedParents = '*';

  render(instruction: RenderInstruction) {
    const getGroup = (e: Element) => !(e instanceof Element) ? null : e.closest('.form-group') ?? (e.matches(this.allowedParents) ? e.querySelector('.form-group') : null);

    for (const { result, elements } of instruction.unrender)
      for (const group of elements.map(e => getGroup(e)))
        if (group != null)
          this.remove(group, result);

    for (const { result, elements } of instruction.render)
      for (const group of elements.map(e => getGroup(e)))
        if (group != null)
          this.add(group, result);
  }

  private add(group: Element, result: ValidateResult) {
    if (result.valid) {
      if (!group.classList.contains('is-invalid'))
        group.classList.add('is-valid');
    }

    else {
      group.classList.remove('is-valid');
      group.classList.add('is-invalid');

      const message = document.createElement('small');
      message.className = 'form-feedback';
      message.textContent = result.message;
      message.id = `form-feedback-${result.id}`;
      group.appendChild(message);
    }
  }

  private remove(group: Element, result: ValidateResult) {
    if (result.valid)
      group.classList.remove('is-valid');

    else {
      const message = group.querySelector(`#form-feedback-${result.id}`);

      if (message)
        group.removeChild(message);
      if (group.querySelectorAll('.form-feedback').length === 0)
        group.classList.remove('is-invalid');
    }
  }
}
